<div class="discount-admin">

  <!-- =====================================================
       CARD CREAR DESCUENTO
  ====================================================== -->

  <div class="discount-create-card">

    <!-- HEADER -->
    <div class="discount-create-header">

      <span class="discount-overline">
        Tarifas y Descuentos
      </span>

      <h2>
        Códigos de descuento
      </h2>

      <p>
        Genera un nuevo cupón definiendo a qué prestación aplica,
        su tipo de descuento, vigencia y a quién está asignado.
      </p>

    </div>


    <form [formGroup]="dctoPost" (ngSubmit)="createCode()">

      <!-- =================================================
           1. PRESTACIÓN
      ================================================== -->
      <section class="discount-form-section">

        <div class="discount-section-title">

          <span class="section-number">
            1
          </span>

          <strong>
            ¿A qué prestación aplica?
          </strong>

        </div>


        <div class="option-pills">

          <!-- MEDICINA GENERAL -->
          <button type="button" class="option-pill" [class.active]="isMedicinaGeneral()"
            (click)="selectPrestacion('1')">

            <span class="radio-dot">
              <span></span>
            </span>

            Medicina General

          </button>


          <!-- ESPECIALIDADES -->
          <button type="button" class="option-pill" [class.active]="isEspecialidades()" (click)="selectPrestacion('2')">

            <span class="radio-dot">
              <span></span>
            </span>

            Especialidades

          </button>

        </div>


        <!-- SELECT ESPECIALIDAD -->
        <div class="discount-field specialty-selector" *ngIf="isEspecialidades()">

          <label>
            Especialidad
          </label>

          <select class="form-control" formControlName="especialidades">

            <option value="">
              Todas las especialidades
            </option>

            <option *ngFor="let especialidad of especialidadesList" [ngValue]="especialidad.sub_spe_id">

              {{ especialidad.spe_name }}

            </option>

          </select>

        </div>

      </section>


      <!-- =================================================
           2. DESCUENTO
      ================================================== -->
      <section class="discount-form-section">

        <div class="discount-section-title">

          <span class="section-number">
            2
          </span>

          <strong>
            Descuento
          </strong>

        </div>


        <div class="discount-type-layout">

          <!-- TIPO -->
          <div class="discount-type-column">

            <label class="field-label">
              Tipo de descuento
            </label>


            <button type="button" class="option-pill wide" [class.active]="isPercentageDiscount()"
              (click)="selectDiscountType('1')">

              <span class="radio-dot">
                <span></span>
              </span>

              Porcentaje (%)

            </button>


            <button type="button" class="option-pill wide" [class.active]="isFixedDiscount()"
              (click)="selectDiscountType('2')">

              <span class="radio-dot">
                <span></span>
              </span>

              Monto fijo ($)

            </button>

          </div>


          <!-- VALOR -->
          <div class="discount-value-column">

            <div class="discount-field">

              <label>
                Valor del descuento
                <span>*</span>
              </label>

              <div class="discount-value-input">

                <span class="value-prefix">
                  {{ isPercentageDiscount() ? '%' : '$' }}
                </span>

                <input type="number" formControlName="monto" placeholder="Ingresa el valor">

              </div>


              <small class="form-error" *ngIf="campoValido('monto')">

                {{ getDiscountValueHelp() }}

              </small>

            </div>

          </div>

        </div>

      </section>


      <!-- =================================================
           3. VIGENCIA
      ================================================== -->
      <section class="discount-form-section">

        <div class="discount-section-title">

          <span class="section-number">
            3
          </span>

          <strong>
            Vigencia y límites
          </strong>

        </div>


        <div class="discount-three-columns">

          <!-- INICIO -->
          <div class="discount-field">

            <label>
              Fecha Inicio
              <span>*</span>
            </label>

            <input type="date" class="form-control" formControlName="fechaInicio">

            <small class="form-error" *ngIf="campoValido('fechaInicio')">

              Debe seleccionar una fecha de inicio.

            </small>

          </div>


          <!-- LÍMITE -->
          <div class="discount-field">

            <label>
              Fecha límite
              <small>(opcional)</small>
            </label>

            <input type="date" class="form-control" formControlName="fechaLimite">

          </div>


          <!-- USOS -->
          <div class="discount-field">

            <label>
              Límite de usos
              <small>(opcional)</small>
            </label>

            <input type="number" class="form-control" formControlName="limiteUso" placeholder="Uso ilimitado">

            <small class="form-error" *ngIf="campoValido('limiteUso')">

              El límite debe estar entre 0 y 10.

            </small>

          </div>

        </div>

      </section>


      <!-- =================================================
           4. ASIGNACIÓN
      ================================================== -->
      <section class="discount-form-section">

        <div class="discount-section-title">

          <span class="section-number">
            4
          </span>

          <strong>
            Asignación
          </strong>

        </div>


        <div class="option-pills">

          <button type="button" class="option-pill" [class.active]="isGeneralAssignment()"
            (click)="selectAssignment('1')">

            <span class="radio-dot">
              <span></span>
            </span>

            General

          </button>


          <button type="button" class="option-pill" [class.active]="isClientAssignment()"
            (click)="selectAssignment('2')">

            <span class="radio-dot">
              <span></span>
            </span>

            Por cliente

          </button>

        </div>


        <!-- CLIENTE + PLAN -->
        <div class="assignment-grid" *ngIf="isClientAssignment()">

          <!-- CLIENTE -->
          <div class="discount-field">

            <label>
              CONVENIO / CLIENTE
            </label>

            <select class="form-control" formControlName="cliente" (ngModelChange)="changeClient($event)">

              <option value="">
                Selecciona un cliente...
              </option>

              <option *ngFor="let cliente of clientes" [ngValue]="cliente.cus_id">

                {{ cliente.cus_name }}

              </option>

            </select>


            <small class="form-error" *ngIf="campoValido('cliente')">

              Debe seleccionar un cliente.

            </small>

          </div>


          <!-- PLAN -->
          <div class="discount-field">

            <label>
              PLAN
            </label>

            <select class="form-control" formControlName="plan">

              <option value="">
                Selecciona un plan...
              </option>

              <option *ngFor="let plan of planesCliente" [ngValue]="plan.cus_ben_id">

                {{ plan.cus_ben_name }}

              </option>

            </select>


            <small class="form-error" *ngIf="campoValido('plan')">

              Debe seleccionar un plan.

            </small>

          </div>

        </div>


        <p class="assignment-helper" *ngIf="isClientAssignment()">

          El código quedará disponible únicamente para pacientes
          del convenio y plan seleccionados (empresa o institución
          con la que AlmaMedis mantiene el convenio).

        </p>

      </section>


      <!-- =================================================
           GENERAR
      ================================================== -->
      <div class="discount-form-actions">

        <button type="submit" class="generate-code-btn" [disabled]="creatingCode">

          <i class="fi fi-rr-plus"></i>

          {{
          creatingCode
          ? 'Generando...'
          : 'Generar código'
          }}

        </button>

      </div>

    </form>

  </div>


  <!-- =====================================================
       CÓDIGOS CREADOS
  ====================================================== -->

  <div class="discount-list-card">

    <!-- HEADER -->
    <div class="discount-list-header">

      <h3>
        Códigos creados
      </h3>


      <div class="discount-list-actions">

        <!-- BUSCADOR -->
        <div class="discount-search">

          <input type="text" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" placeholder="Buscar código...">

          <i class="fi fi-rr-search"></i>

        </div>


        <!-- EXPORTAR -->
        <button type="button" class="export-discounts-btn" (click)="exportDiscountsToExcel()">

          <i class="fi fi-rr-download"></i>

          Exportar a Excel

        </button>

      </div>

    </div>


    <!-- LOADING -->
    <div class="discount-loading" *ngIf="loadingDiscounts">

      Cargando códigos de descuento...

    </div>


    <!-- TABLA -->
    <div class="discount-table-scroll" *ngIf="!loadingDiscounts">

      <table class="discount-table">

        <thead>

          <tr>

            <th>ID</th>

            <th>CÓDIGO</th>

            <th>FECHA INICIO</th>

            <th>FECHA LÍMITE</th>

            <th>ESTADO</th>

            <th>TIPO DESCUENTO</th>

            <th>VALOR DESCUENTO</th>

            <th>USOS</th>

            <th>LÍMITE DE USO</th>

            <th>SUB ESPECIALIDAD</th>

            <th>ASIGNACIÓN</th>

            <th>RESPONSABLE</th>

            <th>ACCIONES</th>

          </tr>

        </thead>


        <tbody>

          <tr *ngFor="let discount of paginatedDiscounts">

            <td>
              {{ getDiscountId(discount) }}
            </td>


            <td>

              <strong class="discount-code">
                {{ getDiscountCode(discount) }}
              </strong>

            </td>


            <td>
              {{ getDiscountStartDate(discount) }}
            </td>


            <td>
              {{ getDiscountEndDate(discount) }}
            </td>


            <td>

              <span class="discount-status" [ngClass]="getDiscountStatusClass(discount)">

                <span class="status-dot"></span>

                {{ getDiscountStatus(discount) }}

              </span>

            </td>


            <td>
              {{ getDiscountType(discount) }}
            </td>


            <td>
              {{ getDiscountValue(discount) }}
            </td>


            <td>
              {{ getDiscountUses(discount) }}
            </td>


            <td>
              {{ getDiscountUseLimit(discount) }}
            </td>


            <td>
              {{ getDiscountSpecialty(discount) }}
            </td>


            <td>
              {{ getDiscountAssignment(discount) }}
            </td>


            <td>
              {{ getDiscountResponsible(discount) }}
            </td>


            <td class="discount-row-actions">

              <button type="button" class="table-action-btn" (click)="editDiscount(discount)">

                Editar

              </button>


              <button type="button" class="table-action-btn" (click)="toggleDiscountStatus(discount)">

                {{ getStatusActionLabel(discount) }}

              </button>

            </td>

          </tr>


          <tr *ngIf="paginatedDiscounts.length === 0">

            <td colspan="13" class="discount-empty">

              No se encontraron códigos de descuento.

            </td>

          </tr>

        </tbody>

      </table>

    </div>


    <!-- ===================================================
         PAGINACIÓN
    ==================================================== -->

    <div class="discount-pagination">

      <div class="discount-page-size">

        <span>
          Cupones por página:
        </span>

        <select [ngModel]="pageSize" (ngModelChange)="changePageSize($event)">

          <option *ngFor="let size of pageSizeOptions" [ngValue]="size">

            {{ size }}

          </option>

        </select>

      </div>


      <span class="discount-page-info">

        {{ firstVisibleItem }}
        –
        {{ lastVisibleItem }}
        de
        {{ totalDiscounts }}

      </span>


      <div class="discount-pagination-buttons">

        <button type="button" [disabled]="currentPage === 1" (click)="firstPage()">

          <i class="fi fi-rr-angle-double-small-left"></i>

        </button>


        <button type="button" [disabled]="currentPage === 1" (click)="previousPage()">

          <i class="fi fi-rr-angle-small-left"></i>

        </button>


        <button type="button" [disabled]="currentPage === totalPages" (click)="nextPage()">

          <i class="fi fi-rr-angle-small-right"></i>

        </button>


        <button type="button" [disabled]="currentPage === totalPages" (click)="lastPage()">

          <i class="fi fi-rr-angle-double-small-right"></i>

        </button>

      </div>

    </div>

  </div>

</div>